import {
  GET_PRODUCTTYPE_FAIL,
  GET_PRODUCTTYPE_SUCCESS,
  GET_PRODUCTTYPES_FAIL,
  GET_PRODUCTTYPES_SUCCESS,
  ADD_PRODUCTTYPE_SUCCESS,
  ADD_PRODUCTTYPE_FAIL,
  UPDATE_PRODUCTTYPE_SUCCESS,
  UPDATE_PRODUCTTYPE_FAIL,
  DELETE_PRODUCTTYPE_SUCCESS,
  DELETE_PRODUCTTYPE_FAIL,  
  SET_STATE_PRODUCTTYPE
} from "./actionTypes";

const INIT_STATE = {
  productTypes: [],
  productType: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const productTypes = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTTYPES_SUCCESS:
      return {
        ...state,
        productTypes: action.payload.productTypes,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_PRODUCTTYPE:
      return { ...state, loading: action.payload }

    case GET_PRODUCTTYPES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_PRODUCTTYPE_SUCCESS:
      return {
        ...state,
        productTypes: [...state.productTypes, action.payload],
      };

    case ADD_PRODUCTTYPE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_PRODUCTTYPE_SUCCESS:
      return {
        ...state,
        productTypes: state.productTypes.map(productType =>
          productType.id.toString() === action.payload.id.toString()
            ? { ...action.payload, productType }
            : productType
        ),
      };

    case UPDATE_PRODUCTTYPE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_PRODUCTTYPE_SUCCESS:
      return {
        ...state,
        productTypes: state.productTypes.filter(
          productType => productType.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_PRODUCTTYPE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_PRODUCTTYPE_SUCCESS:
      return {
        ...state,
        productType: action.payload,
      };

    case GET_PRODUCTTYPE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default productTypes;
